import { inject, Injectable, signal } from '@angular/core';
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root',
})
export class FsApiService {
  private http = inject(HttpClient);
  BASE_URL = environment.baseUrlWeb;

  get<T>(url: string, options?: any): Observable<HttpEvent<T> | T> {
    return this.http.get<T>(this.BASE_URL + url, this.buildOptions(options));
  }

  post<T>(url: string, body: any, options?: any): Observable<HttpEvent<T> | T> {
    return this.http.post<T>(
      this.BASE_URL + url,
      body,
      this.buildOptions(options)
    );
  }

  put<T>(url: string, body: any, options?: any): Observable<HttpEvent<T> | T> {
    return this.http.put<T>(
      this.BASE_URL + url,
      body,
      this.buildOptions(options)
    );
  }

  patch<T>(
    url: string,
    body: any,
    options?: any
  ): Observable<HttpEvent<T> | T> {
    return this.http.patch<T>(
      this.BASE_URL + url,
      body,
      this.buildOptions(options)
    );
  }

  delete<T>(url: string, options?: any): Observable<HttpEvent<T> | T> {
    return this.http.delete<T>(this.BASE_URL + url, this.buildOptions(options));
  }

  private buildOptions(options?: any): any {
    const headers = new HttpHeaders(options?.headers || {});
    const params = new HttpParams({ fromObject: options?.params || {} });

    return { headers, params, ...options };
  }
}
